import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasProgressContainerComponent } from './gas-progress-container.component';
import { GasProgressModule } from '../../common/gas-progress/gas-progress.module';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';

const COMPONENTS = [
  GasProgressContainerComponent,
];

@NgModule({
  declarations: [
    COMPONENTS,
  ],
  exports: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasProgressModule,
    GasIconsModule,
  ],
})
export class GasProgressContainerModule { }
